/**
 * 将 base64 转换为 File 对象
 * @param base64 字符串
 * @param filename 文件名
 * @returns {File} 转换后的文件
 */
export function base64ToFile(base64, filename = 'file') {
    // 分割 base64 字符串，获取类型和数据部分
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/);
    // 解码 base64 数据
    const bstr = atob(arr[1]);
    let n = bstr.length;
    // 创建 Uint8Array 存储解码后的二进制数据
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    // 创建 File 对象
    return new File([u8arr], filename, {type: mime[1]});
}